import { Pricing } from '@alliance-disposal/transport-types';
export const allowedCountries = {
    US: 'United States',
    CA: 'Canada',
};
export const DivisionsByCountry = {
    US: Pricing.USStateAbbreviations,
    CA: Pricing.CAProvinceAbbreviations,
};
export const DivisionsByCountryLabels = {
    US: Pricing.USStateLabels,
    CA: Pricing.CAProvinceLabels,
};
//# sourceMappingURL=divisions-by-country.js.map